
import axios from "axios";
import { decodeToken } from "@okta/okta-auth-js";
// import OktaJwtVerifier from '@okta/jwt-verifier';
import { AuthToken } from "../entities/User";
import { getCxpProfile, getUserProfileFromCxp } from "../services/CxpProfileService";
import { ProgramContainer } from "../entities/formTemplateDataType";
import { AUTH_TOKENS, USER_PROFILE } from "../entities/Constants";
import { jwtDecode } from 'jwt-decode'
import DataUtils from "../utilities/DataUtils";

const MaxTry = 3;

export const signin = async (appId: string, isEng: boolean) => {
    const issuer = process.env.PUBLIC_SECURE_ISSUER;
    const client_id = process.env.PUBLIC_SECURE_CLIENTID;
    const redirect_uri = `${process.env.REDIRECT_URL}`;
    const codeVerifier = generateCodeVerifier();
    const codeChallenge = await generateCodeChallenge(codeVerifier);
    const stateValue = generateState(appId, isEng);

    if(isEng){
        sessionStorage.setItem("lang", isEng.toString());
    } else {
        sessionStorage.setItem("lang", "false");
    }
        

    const params = new URLSearchParams({
        client_id: client_id,
        response_type: 'code',
        scope: 'openid profile email',
        redirect_uri: redirect_uri,
        code_challenge: codeChallenge,
        code_challenge_method: 'S256',
        state: stateValue,
    });


    let authUrl = `${issuer}/v1/authorize?${params.toString()}`;
    if (!isEng) {
        authUrl = authUrl + "&lang=fr"
    }
    // const authUrl = `${issuer}/v1/authorize?client_id=${client_id}&scope=openid%20email%20profile%20offline_access&response_type=code&redirect_uri=${redirect_uri}&lang=en&state=${stateValue}&code_challenge=${codeChallenge}&code_challenge_method=S256`;
    // console.log(authUrl);
    // const url ="https://stage.signin.ontario.ca/oauth2/aus187zrqyTXcJAHA5d7/v1/authorize?client_id=0oa9ra3gm6IkuwYKF5d7&scope=openid%20email%20profile%20offline_access&response_type=code&redirect_uri=https://test.cxp.mgcs.gov.on.ca/otris&lang=en&state=caMM5KcK2B0XbKoO3eh4g1kYc8KtrGVCn1wunAas8Vc&code_challenge=1UiPuv04cbdMO8keZ3Y4t57tNdAdUdIe8H3LBcRDwcg&code_challenge_method=S256"
    sessionStorage.removeItem(AUTH_TOKENS);
    sessionStorage.removeItem(USER_PROFILE);
    window.location.href = authUrl;

    const urlParams = new URLSearchParams(window.location.search);
    const returnedState = urlParams.get('state');
    if (returnedState !== sessionStorage.getItem('stateValue')) {
        throw new Error('Invalid state: possible CSRF attack');
    }
}


export const generateState = (appId: string, isEng: boolean) => {
    const state = sessionStorage.getItem("stateValue");
    if (state && state.endsWith(isEng ? 'EN' : 'FR')) {
        return state;
    }

    const array = new Uint8Array(16);
    window.crypto.getRandomValues(array);
    const stateValue = Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('') + appId + (isEng ? 'EN' : 'FR');

    sessionStorage.setItem("stateValue", stateValue);

    return stateValue;
}

export const getTokens = async (programContainer: ProgramContainer): Promise<AuthToken | null> => {
    const code = new URL(window.location.href).searchParams.get("code");
    const tokens = sessionStorage.getItem(AUTH_TOKENS);
    try {
        const verifier = sessionStorage.getItem("codeVerifier");
        console.log("verifer", verifier);
        if (!verifier) {
            signin(programContainer.CategoryId, !programContainer.Profile?.lang || programContainer.Profile?.lang === 'en');
        }
    } catch (error) {
        signin(programContainer.CategoryId, !programContainer.Profile?.lang || programContainer.Profile.lang === 'en');
    }

    if (!code && !tokens) {
        return null;
    }

    let token = null;
    if (!tokens) {
        console.log('parse tokens: ', tokens);
        token = JSON.parse(tokens);
    }

    try {
        if (!token) {
            const response = await axios.post<AuthToken>(`${process.env.FORM_SERVICE_API_URL}/data/auth/token`,
                { code, code_verifier: generateCodeVerifier() },
                { headers: { "Content-Type": "application/json" } }
            );

            if (response.status !== 200) {
                return null;
            }
            const data = response.data;
            sessionStorage.setItem(AUTH_TOKENS, JSON.stringify(data));
            // sessionStorage.removeItem("codeVerifier");
            console.log("Tokens:", data);
            token = data
        }
        return token;
    } catch (error) {
        console.error("Token Exchange Error:", error.response?.data || error.message);
        return null;
    };
};

export const checkProfileAccount = async (programContainer: ProgramContainer, access_token?: AuthToken) => {
    // return new Promise(resolve => setTimeout(async () => {
    let retied = false
    let authTokens = access_token;
    if (!access_token) {
        authTokens = await getTokens(programContainer);
        if (!authTokens?.access_token) {
            signin(programContainer.CategoryId, !programContainer.Profile?.lang || programContainer.Profile?.lang === 'en');
        }
    } else if (!verifyOktaToken(authTokens.access_token)) {
        signin(programContainer.CategoryId, !programContainer.Profile?.lang || programContainer.Profile?.lang === 'en');
    }

    try {
        const { payload } = decodeToken(authTokens.id_token);
        console.log("decode token:", payload.sub);
        let profile = { ...programContainer.Profile, token: authTokens.access_token, userId: payload.sub, email: payload.email };
        const cxpProfile = await getCxpProfile(authTokens.access_token);

        if (!cxpProfile?.lastName || !cxpProfile?.agreedToTermsOfUseOn) {
            console.log("User does not have cxp account");
            window.location.replace(`${process.env.PUBLIC_CXP_WEB_BASE_PATH}/auth/signin?flow=otris`);
        } else {
            console.log("User has cxp account");
            const userProfile = getUserProfileFromCxp(cxpProfile, authTokens.access_token, payload.sub, payload.email, profile);
            //sessionStorage.setItem(USER_PROFILE, JSON.stringify(userProfile));
            programContainer.Profile = userProfile;
            console.log("profile after fetch cxp profile:", programContainer);
        }
    } catch (error) {
        console.error("Error decode token or fetching CXP profile:", error.response?.data || error.message);
    }
    return programContainer;
    // }, 10000 ));
} 

export const valifyToken = (token): boolean => {

    try {
        const decoded = jwtDecode(token);
        console.log('Decoded token:', decoded);

        // Validate claims
        const now = Math.floor(Date.now() / 1000); // Current time in seconds
        if (decoded.exp < now) {
            console.error('Token has expired');
        } else {
            return true;
        }
    } catch (err) {
        console.error('Invalid token:', err.message);
    }

    return false;
}

export const generateCodeVerifier = () => {
    if (sessionStorage.getItem("codeVerifier")) {
        return sessionStorage.getItem("codeVerifier");
    }

    const array = new Uint8Array(32); // Create a 32-byte array
    window.crypto.getRandomValues(array); // Fill it with random values
    const codeVerifier= btoa(
        String.fromCharCode(...Array.from(array)) // Convert to Base64
    ).replace(/\+/g, '-') // Replace `+` with `-`
        .replace(/\//g, '_') // Replace `/` with `_`
        .replace(/=+$/, ''); // Remove `=` padding

    sessionStorage.setItem("codeVerifier", codeVerifier);

    return codeVerifier;
}

export const generateCodeChallenge = async (verifier) => {
    // if(sessionStorage.getItem("codeChallenge")){
    //     return sessionStorage.getItem("codeChallenge");
    // } else {
    const encoder = new TextEncoder();
    const data = encoder.encode(verifier);
    const digest = await window.crypto.subtle.digest('SHA-256', data); // Generate SHA-256 hash
    const codeChallenge = btoa(String.fromCharCode(...Array.from(new Uint8Array(digest)))) // Convert to Base64
        .replace(/\+/g, '-') // Replace `+` with `-`
        .replace(/\//g, '_') // Replace `/` with `_`
        .replace(/=+$/, ''); // Remove `=` padding
    return codeChallenge;
    // }
}

export const fetchSessionFromServer = async (programContainer: ProgramContainer) => {
    try {
        const response = await fetch(`${process.env.PUBLIC_CXP_WEB_BASE_PATH}/api/auth/session`, {
            credentials: 'include', // Ensure cookies are sent with the request
        });

        if (response.ok) {
            const data = await response.json();
            // sessionStorage.setItem(AUTH_TOKENS, JSON.stringify(data));
            const profile = { ...programContainer.Profile, token: data?.accessToken };
            programContainer.Profile = profile;
            // sessionStorage.setItem(USER_PROFILE, JSON.stringify(profile));
            console.log('Session Data:', data);
            console.log(programContainer)

        } else {
            console.error('Failed to fetch session');
        }
    } catch (ex) {

    }

    return programContainer;
};

export const clearSessionStorage = () => {
    sessionStorage.removeItem(AUTH_TOKENS);
    sessionStorage.removeItem(USER_PROFILE);
    sessionStorage.removeItem("codeVerifier");
    sessionStorage.removeItem("codeChallenge");
    sessionStorage.removeItem("stateValue");
}

export const cleanup = (app: string, programContainer: ProgramContainer) => {
    clearSessionStorage();
    localStorage.removeItem("userProfile");
    DataUtils.clearFormValue(programContainer);
}

export const cleanSession = (app: string, profile: any, lang: 'en' | 'fr' = 'en') => {
    clearSessionStorage();
    if (profile?.token) {
        const url = process.env.PUBLIC_CXP_WEB_BASE_PATH + "/auth/signin?redirectUri=" + (lang === 'en' ? '/logout/' : '/fr/logout/') + app.toLowerCase();
        window.location.replace(url);
    } else if (profile) {
        window.location.replace(lang === 'en' ? process.env.CXP_URL : process.env.CXP_URL_F);
    } else {
        window.location.replace(lang === 'en' ? process.env.SERVICEONTARIO_URL : process.env.SERVICEONTARIO_URL_F);
    }
}

// const oktaJwtVerifier = new OktaJwtVerifier({
//     issuer: process.env.PUBLIC_SECURE_ISSUER, 
//     clientId: process.env.PUBLIC_SECURE_CLIENTID,
//   });

// export const verifyOktaToken = async (token: string) => {
//     try {
//         const { payload } = decodeToken(token);
//         const jwt = await oktaJwtVerifier.verifyAccessToken(token, payload.aud); 
//         console.log('Token is valid:', jwt.claims);
//         return !jwt.isExpired();
//       } catch (err) {
//         console.error('Token verification failed:', err.message);
//       }
//       return false;
// }
  
const verifyOktaToken = (token: string) => {
    try {
      const { payload } = decodeToken(token);
      console.log('Token is valid:', payload);
      const deadLine = Math.floor(Date.now() / 1000) + 300;
      if (payload.exp < deadLine) {
        console.log('Token has expired');
        return false;
      }
    } catch (error) {
      console.error('Token verification failed:', error.message);
      return false
    }
    return true;
  }